class ReportingController {
    /*@ngInject*/
    constructor(Auth, $state, User, UserService, $translate, $location, Modal, DataCounter, $q, $rootScope) {

        this.$state = $state

        this.$translate = $translate;
        this.Auth = Auth;
        this.$state = $state;
        this.User = User;
        this.$q = $q;
        this.$location = $location;
        this.Modal = Modal;
        this.DataCounter = DataCounter;
        this.$rootScope = $rootScope;
        this.currentBranch = User.getUser().branchId;

        this.tabConfig = {
            'reporting_liability': {
                title: 'Liability',
                state: 'liability',
            },
            'reporting_route_performance': {
                title: 'Route Performance',
                state: 'route_performance',
            },
            'reporting_on_hold': {
                title: 'On Hold',
                state: 'on_hold',
            },
        };

        this.acl = User.getACL('_reporting');
        this.tabs = [];
    }

    getStateDiff(array) {
        let diff = []
        let index = 0
        for (let i = 0; i < array.length; i++) {
            let key = array[i];
            if (!(key in this.acl)) {
                diff[index++] = array[i]
            }
        }
        return diff
    }

    $onInit() {
        let toDeregister = this.getStateDiff(Object.keys(this.tabConfig))
        for (let i = 0; i < toDeregister.length; i++) {
            if (this.$state.get(toDeregister[i])) {
                this.$state.router.stateRegistry.deregister(toDeregister[i])
            }
        }
        
        _.forEach(Object.keys(this.tabConfig), (key, i) => {
            if (this.acl[key] && this.acl[key].indexOf('view') >= 0) {
                let tabConfig = this.tabConfig[key];
                if (tabConfig) {
                    let obj = Object.assign(tabConfig, { key })
                    this.tabs.push(obj);
                }
            }
        })
        if (this.$state.current.name == 'reporting' && this.tabs.length) {
            this.$state.go(this.tabs[0].state)
        }

        this.$rootScope.$broadcast('routeChange', null);
    }

    hasAcl(key) {
        if (this.acl[key] && this.acl[key].indexOf('view') >= 0) {
            return true;
        } else {
            return false;
        }
    }
}

export default ReportingController;


// WEBPACK FOOTER //
// ./client/app/components/reporting/reporting.controller.js